module.exports = new __parcel__URL__("mainframe_level_8.b494bcf4.png").toString();